const apiPath = "/customs/customs-brokers";
const path = "CustomsBrokersModule";

const CustomsBrokersAPIsConstants = {
  API_PATH: `${apiPath}`,
};

const CustomsBrokersActions = {
  ADD_ITEM: `${path}/addItem`,
  UPDATE_ITEM: `${path}/updateItem`,
  EDIT_ITEM: `${path}/editItem`,
  FIND_ITEM_BY_ID: `${path}/findItemById`,
  GET_INIT_DATA : `${path}/getInitData`,
};

export { CustomsBrokersAPIsConstants, CustomsBrokersActions };
